/**
 * Online status reactive store using Svelte 5 Runes ($state).
 * Monitors browser network connectivity.
 */

class OnlineStore {
	isOnline = $state(typeof navigator !== 'undefined' ? navigator.onLine : true);

	constructor() {
		if (typeof window !== 'undefined') {
			window.addEventListener('online', () => {
				this.isOnline = true;
			});
			window.addEventListener('offline', () => {
				this.isOnline = false;
			});
		}
	}
}

export const onlineStore = new OnlineStore();
